var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon7(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 142,
    height: 140,
    viewBox: "0 0 142 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 86.8389,
    height: 86.8389,
    rx: 10,
    transform: "matrix(0.817606 -0.575779 0.817606 0.575779 0 90)",
    fill: "#F4387C"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 86.8389,
    height: 86.8389,
    rx: 10,
    transform: "matrix(0.817606 -0.575779 0.817606 0.575779 0 90)",
    fill: "url(#paint0_linear_45_629)",
    fillOpacity: 0.2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 86.8389,
    height: 86.8389,
    rx: 10,
    transform: "matrix(0.817606 -0.575779 0.817606 0.575779 0 71)",
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 86.8389,
    height: 86.8389,
    rx: 10,
    transform: "matrix(0.817606 -0.575779 0.817606 0.575779 0 71)",
    fill: "url(#paint1_linear_45_629)",
    fillOpacity: 0.2
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 86.8389,
    height: 86.8389,
    rx: 10,
    transform: "matrix(0.817606 -0.575779 0.817606 0.575779 0 50)",
    fill: "#1D36E8"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 86.8389,
    height: 86.8389,
    rx: 10,
    transform: "matrix(0.817606 -0.575779 0.817606 0.575779 0 50)",
    fill: "url(#paint2_linear_45_629)",
    fillOpacity: 0.2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_45_629",
    x1: 29.6977,
    y1: 86.8389,
    x2: 8.68686,
    y2: 13.9715,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CF2930"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#661519"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_45_629",
    x1: 29.6977,
    y1: 86.8389,
    x2: 8.68686,
    y2: 13.9715,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A2A2A2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_45_629",
    x1: 42.7278,
    y1: 86.8389,
    x2: 42.8462,
    y2: -0.00172421,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D36E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#182378"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon7);
export default __webpack_public_path__ + "static/media/icon7.4c6b77c49e5d7fab8ef124af6bf93728.svg";
export { ForwardRef as ReactComponent };